import { render, staticRenderFns } from "./RxFormatted.vue?vue&type=template&id=5feebd85&scoped=true&"
import script from "./RxFormatted.vue?vue&type=script&lang=js&"
export * from "./RxFormatted.vue?vue&type=script&lang=js&"
import style0 from "./RxFormatted.vue?vue&type=style&index=0&id=5feebd85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feebd85",
  null
  
)

export default component.exports